import { alpha, Theme } from '@mui/material';
import { LOG_LEVEL_PALETTE_COLORS, LogLevel } from './logLevels.ts';

const levelColor = (theme: Theme, level: LogLevel) => theme.palette[LOG_LEVEL_PALETTE_COLORS[level]].main;

export const logLevelFilterButtonStyle = (level: LogLevel) => (theme: Theme) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '16px',
  padding: theme.spacing(0.25, 1),
  fontSize: '0.68rem',
  fontWeight: 600,
  letterSpacing: '0.04em',
  lineHeight: 1.6,
  color: theme.palette.text.secondary,
  transition: theme.transitions.create(['background-color', 'border-color', 'color']),
  '&:hover': {
    borderColor: alpha(levelColor(theme, level), 0.5),
    backgroundColor: alpha(levelColor(theme, level), 0.08),
  },
  '&.Mui-selected': {
    color: levelColor(theme, level),
    borderColor: alpha(levelColor(theme, level), 0.5),
    backgroundColor: alpha(levelColor(theme, level), 0.14),
    '&:hover': {
      backgroundColor: alpha(levelColor(theme, level), 0.22),
    },
  },
});
